import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  Box, Stepper, Step, StepLabel, Button, Typography, Paper, Grid, TextField, Select, MenuItem, IconButton
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useSelector } from 'react-redux';
import StockorderproductDashboard from 'components/stockorderproduct/StockorderproductDashboard';
import { setStockOrderObj, setSupplierId } from 'store/slice/AppSlice';
import { getListAPI, updateStockorderInfo } from '../StockorderAPI';
import { setStockorderList, setStockorderproductDashboardStockorderproductList, updateStockorderObj, setSelectedWorkerId, updateStockorderproductObj } from 'store/slice/ManufSlice';
import StockorderPage from './StockorderPage';
import { getStockorderproductInfoByStockorderidAPI } from 'components/stockorderproduct/StockorderproductAPI';
import { placeStockOrderAPI } from 'api/OmsFactoryopsWebServices';
import { updateStockOrderPartyAPI } from 'api/OmsFactoryopsWebServices';
import StockorderproductPage from 'components/stockorderproduct/page/StockorderproductPage';
import Radio from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import { setSupplierTypeId } from 'store/slice/AppSlice';

const steps = ['Select Supplier', 'Add Product', 'Order Confirmation'];

const mockSuppliers = [
  { id: 1, name: 'Supplier A' },
  { id: 2, name: 'Supplier B' },
];

const mockProducts = [
  { id: 1, name: 'Product X' },
  { id: 2, name: 'Product Y' },
];

export default function StockInMgmt() {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  //const [supplier, setSupplier] = useState('');
  const [products, setProducts] = useState([]);
  const [productForm, setProductForm] = useState({ product: '', qty: '', price: '' });
  const [editIdx, setEditIdx] = useState(null);
  const { supplierId } = useSelector((state) => state.appslice);
  const [partyType, setPartyType] = useState(0); // 'supplier' or 'worker'
  const { workerList } = useSelector((state) => state.manufslice);

  const { mfpartyList } = useSelector((state) => state.manufslice);
  const [supplierList, setSupplierList] = useState(mfpartyList.filter(partyObj => partyObj.stocker));
  const { stockorderObj } = useSelector((state) => state.manufslice.stockorderDashboard);
  const { stockorderproductList } = useSelector((state) => state.manufslice.stockorderproductDashboard);
  const { stockorderproductObj } = useSelector((state) => state.manufslice.stockorderproductDashboard);

  const partyList = partyType == 1
    ? mfpartyList.filter(partyObj => partyObj.stocker)
    : workerList || [];

  const [supplierApiError, setSupplierApiError] = useState('');
  const [placeOrderApiError, setPlaceOrderApiError] = useState('');

  useEffect(() => {
    console.log('StockInMgmt useEffect - stockorderObj:', JSON.stringify(stockorderObj));
    if (stockorderObj.id !== undefined) {
      // Set Party
      dispatch(setSupplierId(stockorderObj.partyid));

      // Fetch product List of selected Stock Order
      getStockorderproductInfoByStockorderidAPI(stockorderObj.id, () => { }, (data) => {
        dispatch(setStockorderproductDashboardStockorderproductList(data));
      });
    }
  }, [stockorderObj]);

  useEffect(() => {
    if (activeStep === 1 && stockorderObj && stockorderObj.id) {
      getStockorderproductInfoByStockorderidAPI(stockorderObj.id, () => { }, (data) => {
        dispatch(setStockorderproductDashboardStockorderproductList(data));
      });
    } else {
      dispatch(setStockorderproductDashboardStockorderproductList([]));
    }
  }, [activeStep]);
  // useEffect(() => {
  //   setSupplier(stockorderObj.partyid);
  // },[supplierId]);

  // Step 1: Select Supplier
  const handleSupplierChange = (e) => {
    setSupplierApiError('');
    dispatch(setSupplierId(e.target.value));
    dispatch(setSelectedWorkerId(e.target.value));


    if (stockorderObj.id !== undefined && stockorderObj.partyid !== e.target.value) {
      updateStockOrderPartyAPI({
        partyId: e.target.value,
        stockOrderId: stockorderObj.id,
        typeId: stockorderObj.partytypeid
      }, (apiResponse) => {
        dispatch(updateStockorderObj(apiResponse.stockorderInfo));
        apiResponse.stockorderproductInfoList.list.forEach(product => {
          dispatch(updateStockorderproductObj(product));
        });
        setSupplierApiError('');
      }, (error) => {
        console.error('Error updating party:', error);
        setSupplierApiError(error || 'Failed to update supplier. Please try again.');
      })
    }

    // dispatch(setStockOrderObj({
    //   partyid: e.target.value,
    // }));
  }

  // Step 2: Add/Edit Product
  const handleProductFormChange = (e) => {
    setProductForm({ ...productForm, [e.target.name]: e.target.value });
  };

  const handleAddProduct = () => {
    if (!productForm.product || !productForm.qty || !productForm.price) return;
    if (editIdx !== null) {
      const updated = [...products];
      updated[editIdx] = productForm;
      setProducts(updated);
      setEditIdx(null);
    } else {
      setProducts([...products, productForm]);
    }
    setProductForm({ product: '', qty: '', price: '' });
  };

  const handleEditProduct = (idx) => {
    setProductForm(products[idx]);
    setEditIdx(idx);
    setActiveStep(1);
  };

  // Step navigation
  const handleNext = () => setActiveStep((prev) => prev + 1);
  const handleBack = () => setActiveStep((prev) => prev - 1);

  // Step 3: Place Order (simulate)
  const handlePlaceOrder = () => {
    setPlaceOrderApiError('');
    placeStockOrderAPI(
      {
        stockOrderId: stockorderObj.id,
      },
      (apiResponse) => {
        console.log('Order placed successfully:', apiResponse);
        dispatch(updateStockorderObj(apiResponse.stockorderInfo));
        setActiveStep(3);
      },
      (error) => {
        console.error('Error placing order:', error);
        setPlaceOrderApiError(error || 'Failed to place order. Please try again.');
      }
    );
  };
  const handleSupplierTypeChange = (e) => {
    setPartyType(e.target.value);
    dispatch(setSupplierTypeId(e.target.value));
    updateStockorderInfo(stockorderObj.id, {
      partytypeid: e.target.value
    },
      (response) => {
        dispatch(updateStockorderObj(response));
      },
      (error) => {
        console.error('Error updating party type:', error);
        // Handle error (e.g., show notification)
      }
    );
  }

  // Responsive layout
  return (
    <Box sx={{ width: '100%', mx: 'auto', }}>
      <Paper sx={{ pt: 2 }}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(label => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Step 1: Select Supplier */}
        {activeStep === 0 && (
          <Box sx={{ mt: 2, p: 1, }}>
            <Grid container direction="row" gap={2} justifyContent="space-between" alignItems="top">
              <Grid item lg={3} xs={12} sx={{ backgroundColor: 'secondary.100', p: 1, borderRadius: 2 }}>
                <Typography variant="h6" gutterBottom>Select Type</Typography>
                <RadioGroup
                  row
                  value={partyType}
                  onChange={handleSupplierTypeChange}
                  sx={{ backgroundColor: 'white', p: 1, borderRadius: 2 }}
                >
                  <FormControlLabel value="0" control={<Radio />} label="Worker" />
                  <FormControlLabel value="1" control={<Radio />} label="Supplier" />
                </RadioGroup>

              </Grid>

              <Grid item lg={8} xs={12} sx={{ backgroundColor: 'secondary.100', p: 1, borderRadius: 2 }}>
                <Typography variant="h6" gutterBottom>
                  {partyType == 1 ? 'Select Supplier' : 'Select Worker'}
                </Typography>
                <Select
                  fullWidth
                  value={supplierId}
                  onChange={handleSupplierChange}
                  displayEmpty
                  sx={{ mb: 2, mb: 5 }}
                >
                  <MenuItem value="" disabled>
                    {partyType == 1 ? 'Select supplier' : 'Select worker'}
                  </MenuItem>
                  {partyList.map(s => (
                    <MenuItem key={s.id} value={s.id}>{s.title || s.name}</MenuItem>
                  ))}
                </Select>
                {supplierApiError && (
                  <Typography color="error" variant="body2" sx={{ mt: -3, mb: 2 }}>
                    {supplierApiError}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
              <Box sx={{ display: 'flex', }}>
                <Button
                  variant="contained"
                  disabled={!supplierId}
                  onClick={handleNext}
                >
                  Next
                </Button>
              </Box>
            </Grid>



          </Box>
        )}

        {/* Step 2: Add Product */}
        {activeStep === 1 && (
          <Box sx={{ width: '100%', height: { lg: '60vh', xs: '65vh' }, mt: 2, p: 1 }}>
            {/* <Typography variant="h6" gutterBottom>Add Product</Typography> */}
            <Grid container sx={{ width: '100%' }}>
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mb: 2 }}>
                <StockorderproductDashboard />
              </Grid>
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mb: 2, borderTop: '1px solid #ccc', }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'bottom', mt: 2 }}>
                  <Button onClick={handleBack}>Back</Button>
                  <Box>
                  {placeOrderApiError && (
                  <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                    {placeOrderApiError}
                  </Typography>
                )}
                </Box>
                  <Button
                    variant="contained"
                    disabled={stockorderproductList.length === 0}
                    onClick={handlePlaceOrder}
                    color="success"
                  >
                    Place Order
                  </Button>

                </Box>
                
              </Grid>
              
              { }
            </Grid>

          </Box>
        )}



        {/* Step 4: Success */}
        {activeStep === 3 && (
          <Box sx={{ mt: 6, textAlign: 'center', pb: 4 }}>
            <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60, mb: 2 }} />
            <Typography variant="h5" color="success.main" gutterBottom>
              Order # {stockorderObj.id} is Placed Successfully!
            </Typography>
            {/* <Typography variant="body1">Your stock-in order has been recorded.</Typography> */}
          </Box>
        )}
      </Paper>
    </Box>
  );
}